/* eslint-disable max-lines */
export const phoneCountries = Object.freeze(
    [
        {
            'textLabel': 'Afghanistan',
            'value': 'AF',
            'label': '+93'
        },
        {
            'textLabel': 'Angola',
            'value': 'AO',
            'label': '+244'
        },
        {
            'textLabel': 'Argentina',
            'value': 'AR',
            'label': '+54'
        },
        {
            'textLabel': 'Armenia',
            'value': 'AM',
            'label': '+374'
        },
        {
            'textLabel': 'Aruba',
            'value': 'AW',
            'label': '+297'
        },
        {
            'textLabel': 'Australia',
            'value': 'AU',
            'label': '+61'
        },
        {
            'textLabel': 'Austria',
            'value': 'AT',
            'label': '+43'
        },
        {
            'textLabel': 'Bahrain',
            'value': 'BH',
            'label': '+973'
        },
        {
            'textLabel': 'Bangladesh',
            'value': 'BD',
            'label': '+880'
        },
        {
            'textLabel': 'Belarus',
            'value': 'BY',
            'label': '+375'
        },
        {
            'textLabel': 'Belgium',
            'value': 'BE',
            'label': '+32'
        },
        {
            'textLabel': 'Belize',
            'value': 'BZ',
            'label': '+501'
        },
        {
            'textLabel': 'Benin',
            'value': 'BJ',
            'label': '+229'
        },
        {
            'textLabel': 'Bhutan',
            'value': 'BT',
            'label': '+975'
        },
        {
            'textLabel': 'Bolivarian Republic of Venezuela',
            'value': 'VE',
            'label': '+58'
        },
        {
            'textLabel': 'Bolivia',
            'value': 'BO',
            'label': '+591'
        },
        {
            'textLabel': 'Bosnia and Herzegovina',
            'value': 'BA',
            'label': '+387'
        },
        {
            'textLabel': 'Botswana',
            'value': 'BW',
            'label': '+267'
        },
        {
            'textLabel': 'Brazil',
            'value': 'BR',
            'label': '+55'
        },
        {
            'textLabel': 'British Indian Ocean Territory',
            'value': 'IO',
            'label': '+246'
        },
        {
            'textLabel': 'Burundi',
            'value': 'BI',
            'label': '+257'
        },
        {
            'textLabel': 'Cabo Verde',
            'value': 'CV',
            'label': '+238'
        },
        {
            'textLabel': 'Cameroon',
            'value': 'CM',
            'label': '+237'
        },
        {
            'textLabel': 'Central African Republic',
            'value': 'CF',
            'label': '+236'
        },
        {
            'textLabel': 'Chad',
            'value': 'TD',
            'label': '+235'
        },
        {
            'textLabel': 'Chile',
            'value': 'CL',
            'label': '+56'
        },
        {
            'textLabel': 'China',
            'value': 'CN',
            'label': '+86'
        },
        {
            'textLabel': 'Colombia',
            'value': 'CO',
            'label': '+57'
        },
        {
            'textLabel': 'Congo',
            'value': 'CG',
            'label': '+242'
        },
        {
            'textLabel': 'Congo (DRC)',
            'value': 'CD',
            'label': '+243'
        },
        {
            'textLabel': 'Cook Islands',
            'value': 'CK',
            'label': '+682'
        },
        {
            'textLabel': 'Costa Rica',
            'value': 'CR',
            'label': '+506'
        },
        {
            'textLabel': 'Croatia',
            'value': 'HR',
            'label': '+385'
        },
        {
            'textLabel': 'Cuba',
            'value': 'CU',
            'label': '+53'
        },
        {
            'textLabel': 'Curaçao',
            'value': 'CW',
            'label': '+599'
        },
        {
            'textLabel': 'Cyprus',
            'value': 'CY',
            'label': '+357'
        },
        {
            'textLabel': 'Denmark',
            'value': 'DK',
            'label': '+45'
        },
        {
            'textLabel': 'Ecuador',
            'value': 'EC',
            'label': '+593'
        },
        {
            'textLabel': 'Egypt',
            'value': 'EG',
            'label': '+20'
        },
        {
            'textLabel': 'Equatorial Guinea',
            'value': 'GQ',
            'label': '+240'
        },
        {
            'textLabel': 'Estonia',
            'value': 'EE',
            'label': '+372'
        },
        {
            'textLabel': 'Ethiopia',
            'value': 'ET',
            'label': '+251'
        },
        {
            'textLabel': 'Falkland Islands (Islas Malvinas)',
            'value': 'FK',
            'label': '+500'
        },
        {
            'textLabel': 'Fiji Islands',
            'value': 'FJ',
            'label': '+679'
        },
        {
            'textLabel': 'Finland',
            'value': 'FI',
            'label': '+358'
        },
        {
            'textLabel': 'France',
            'value': 'FR',
            'label': '+33'
        },
        {
            'textLabel': 'Gambia, The',
            'value': 'GM',
            'label': '+220'
        },
        {
            'textLabel': 'Georgia',
            'value': 'GE',
            'label': '+995'
        },
        {
            'textLabel': 'Germany',
            'value': 'DE',
            'label': '+49'
        },
        {
            'textLabel': 'Ghana',
            'value': 'GH',
            'label': '+233'
        },
        {
            'textLabel': 'Gibraltar',
            'value': 'GI',
            'label': '+350'
        },
        {
            'textLabel': 'Greece',
            'value': 'GR',
            'label': '+30'
        },
        {
            'textLabel': 'Greenland',
            'value': 'GL',
            'label': '+299'
        },
        {
            'textLabel': 'Guatemala',
            'value': 'GT',
            'label': '+502'
        },
        {
            'textLabel': 'Guinea-Bissau',
            'value': 'GW',
            'label': '+245'
        },
        {
            'textLabel': 'Guyana',
            'value': 'GY',
            'label': '+592'
        },
        {
            'textLabel': 'Haiti',
            'value': 'HT',
            'label': '+509'
        },
        {
            'textLabel': 'Hungary',
            'value': 'HU',
            'label': '+36'
        },
        {
            'textLabel': 'Indonesia',
            'value': 'ID',
            'label': '+62'
        },
        {
            'textLabel': 'Iran',
            'value': 'IR',
            'label': '+98'
        },
        {
            'textLabel': 'Iraq',
            'value': 'IQ',
            'label': '+964'
        },
        {
            'textLabel': 'Ireland',
            'value': 'IE',
            'label': '+353'
        },
        {
            'textLabel': 'Israel',
            'value': 'IL',
            'label': '+972'
        },
        {
            'textLabel': 'Italy',
            'value': 'IT',
            'label': '+39'
        },
        {
            'textLabel': 'Jordan',
            'value': 'JO',
            'label': '+962'
        },
        {
            'textLabel': 'Kazakhstan',
            'value': 'KZ',
            'label': '+7'
        },
        {
            'textLabel': 'Kenya',
            'value': 'KE',
            'label': '+254'
        },
        {
            'textLabel': 'Kiribati',
            'value': 'KI',
            'label': '+686'
        },
        {
            'textLabel': 'Kyrgyzstan',
            'value': 'KG',
            'label': '+996'
        },
        {
            'textLabel': 'Laos',
            'value': 'LA',
            'label': '+856'
        },
        {
            'textLabel': 'Latvia',
            'value': 'LV',
            'label': '+371'
        },
        {
            'textLabel': 'Liberia',
            'value': 'LR',
            'label': '+231'
        },
        {
            'textLabel': 'Libya',
            'value': 'LY',
            'label': '+218'
        },
        {
            'textLabel': 'Lithuania',
            'value': 'LT',
            'label': '+370'
        },
        {
            'textLabel': 'Luxembourg',
            'value': 'LU',
            'label': '+352'
        },
        {
            'textLabel': 'Madagascar',
            'value': 'MG',
            'label': '+261'
        },
        {
            'textLabel': 'Malawi',
            'value': 'MW',
            'label': '+265'
        },
        {
            'textLabel': 'Malaysia',
            'value': 'MY',
            'label': '+60'
        },
        {
            'textLabel': 'Mali',
            'value': 'ML',
            'label': '+223'
        },
        {
            'textLabel': 'Malta',
            'value': 'MT',
            'label': '+356'
        },
        {
            'textLabel': 'Mauritania',
            'value': 'MR',
            'label': '+222'
        },
        {
            'textLabel': 'Mauritius',
            'value': 'MU',
            'label': '+230'
        },
        {
            'textLabel': 'Mayotte',
            'value': 'YT',
            'label': '+262'
        },
        {
            'textLabel': 'Mexico',
            'value': 'MX',
            'label': '+52'
        },
        {
            'textLabel': 'Micronesia',
            'value': 'FM',
            'label': '+691'
        },
        {
            'textLabel': 'Moldova',
            'value': 'MD',
            'label': '+373'
        },
        {
            'textLabel': 'Monaco',
            'value': 'MC',
            'label': '+377'
        },
        {
            'textLabel': 'Mongolia',
            'value': 'MN',
            'label': '+976'
        },
        {
            'textLabel': 'Montenegro',
            'value': 'ME',
            'label': '+382'
        },
        {
            'textLabel': 'Morocco',
            'value': 'MA',
            'label': '+212'
        },
        {
            'textLabel': 'Mozambique',
            'value': 'MZ',
            'label': '+258'
        },
        {
            'textLabel': 'Myanmar',
            'value': 'MM',
            'label': '+95'
        },
        {
            'textLabel': 'Namibia',
            'value': 'NA',
            'label': '+264'
        },
        {
            'textLabel': 'Nauru',
            'value': 'NR',
            'label': '+674'
        },
        {
            'textLabel': 'Nepal',
            'value': 'NP',
            'label': '+977'
        },
        {
            'textLabel': 'Netherlands',
            'value': 'NL',
            'label': '+31'
        },
        {
            'textLabel': 'New Zealand',
            'value': 'NZ',
            'label': '+64'
        },
        {
            'textLabel': 'Niger',
            'value': 'NE',
            'label': '+227'
        },
        {
            'textLabel': 'Nigeria',
            'value': 'NG',
            'label': '+234'
        },
        {
            'textLabel': 'North Korea',
            'value': 'KP',
            'label': '+850'
        },
        {
            'textLabel': 'Norway',
            'value': 'NO',
            'label': '+47'
        },
        {
            'textLabel': 'Oman',
            'value': 'OM',
            'label': '+968'
        },
        {
            'textLabel': 'Pakistan',
            'value': 'PK',
            'label': '+92'
        },
        {
            'textLabel': 'Palau',
            'value': 'PW',
            'label': '+680'
        },
        {
            'textLabel': 'Paraguay',
            'value': 'PY',
            'label': '+595'
        },
        {
            'textLabel': 'Peru',
            'value': 'PE',
            'label': '+51'
        },
        {
            'textLabel': 'Philippines',
            'value': 'PH',
            'label': '+63'
        },
        {
            'textLabel': 'Poland',
            'value': 'PL',
            'label': '+48'
        },
        {
            'textLabel': 'Qatar',
            'value': 'QA',
            'label': '+974'
        },
        {
            'textLabel': 'Reunion',
            'value': 'RE',
            'label': '+262'
        },
        {
            'textLabel': 'Romania',
            'value': 'RO',
            'label': '+40'
        },
        {
            'textLabel': 'Russia',
            'value': 'RU',
            'label': '+7'
        },
        {
            'textLabel': 'Rwanda',
            'value': 'RW',
            'label': '+250'
        },
        {
            'textLabel': 'Saint Barthélemy',
            'value': 'BL',
            'label': '+590'
        },
        {
            'textLabel': 'Samoa',
            'value': 'WS',
            'label': '+685'
        },
        {
            'textLabel': 'San Marino',
            'value': 'SM',
            'label': '+378'
        },
        {
            'textLabel': 'Saudi Arabia',
            'value': 'SA',
            'label': '+966'
        },
        {
            'textLabel': 'Senegal',
            'value': 'SN',
            'label': '+221'
        },
        {
            'textLabel': 'Seychelles',
            'value': 'SC',
            'label': '+248'
        },
        {
            'textLabel': 'Sierra Leone',
            'value': 'SL',
            'label': '+232'
        },
        {
            'textLabel': 'Singapore',
            'value': 'SG',
            'label': '+65'
        },
        {
            'textLabel': 'Somalia',
            'value': 'SO',
            'label': '+252'
        },
        {
            'textLabel': 'South Africa',
            'value': 'ZA',
            'label': '+27'
        },
        {
            'textLabel': 'South Sudan',
            'value': 'SS',
            'label': '+211'
        },
        {
            'textLabel': 'Spain',
            'value': 'ES',
            'label': '+34'
        },
        {
            'textLabel': 'Sudan',
            'value': 'SD',
            'label': '+249'
        },
        {
            'textLabel': 'Suriname',
            'value': 'SR',
            'label': '+597'
        },
        {
            'textLabel': 'Sweden',
            'value': 'SE',
            'label': '+46'
        },
        {
            'textLabel': 'Switzerland',
            'value': 'CH',
            'label': '+41'
        },
        {
            'textLabel': 'Syria',
            'value': 'SY',
            'label': '+963'
        },
        {
            'textLabel': 'Tajikistan',
            'value': 'TJ',
            'label': '+992'
        },
        {
            'textLabel': 'Tanzania',
            'value': 'TZ',
            'label': '+255'
        },
        {
            'textLabel': 'Thailand',
            'value': 'TH',
            'label': '+66'
        },
        {
            'textLabel': 'Togo',
            'value': 'TG',
            'label': '+228'
        },
        {
            'textLabel': 'Tokelau',
            'value': 'TK',
            'label': '+690'
        },
        {
            'textLabel': 'Tonga',
            'value': 'TO',
            'label': '+676'
        },
        {
            'textLabel': 'Turkmenistan',
            'value': 'TM',
            'label': '+993'
        },
        {
            'textLabel': 'Tuvalu',
            'value': 'TV',
            'label': '+688'
        },
        {
            'textLabel': 'Uganda',
            'value': 'UG',
            'label': '+256'
        },
        {
            'textLabel': 'United Arab Emirates',
            'value': 'AE',
            'label': '+971'
        },
        {
            'textLabel': 'Uruguay',
            'value': 'UY',
            'label': '+598'
        },
        {
            'textLabel': 'Uzbekistan',
            'value': 'UZ',
            'label': '+998'
        },
        {
            'textLabel': 'Wallis and Futuna',
            'value': 'WF',
            'label': '+681'
        },
        {
            'textLabel': 'Yemen',
            'value': 'YE',
            'label': '+967'
        },
        {
            'textLabel': 'Zambia',
            'value': 'ZM',
            'label': '+260'
        }
    ]
);